import { render, staticRenderFns } from "./CategoryModal.vue?vue&type=template&id=4faa627e&"
import script from "./CategoryModal.vue?vue&type=script&lang=js&"
export * from "./CategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4faa627e')) {
      api.createRecord('4faa627e', component.options)
    } else {
      api.reload('4faa627e', component.options)
    }
    module.hot.accept("./CategoryModal.vue?vue&type=template&id=4faa627e&", function () {
      api.rerender('4faa627e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/components/CategoryModal.vue"
export default component.exports